const questions = [{
        id: 1,
        title: 'Notification 1',
        info: 'Unicorn vinyl poutine brooklyn, next level direct trade iceland. Shaman copper mug church-key coloring book, whatever poutine normcore fixie cred kickstarter post-ironic street art.',
    },
    {
        id: 2,
        title: 'Notification 2 Notification 8',
        info: 'Coloring book forage photo booth gentrify lumbersexual. Migas chillwave poutine synth shoreditch, enamel pin thundercats fashion axe roof party polaroid chartreuse.',
    },
    {
        id: 3,
        title: 'Notification 3 Notification 8',
        info: 'Enamel pin fam sustainable woke whatever venmo. Authentic asymmetrical put a bird on it, lumbersexual activated charcoal kinfolk banjo cred pickled sartorial.',
    },
    {
        id: 4,
        title: 'Notification 4 Notification 8 Notification 8 ',
        info: 'Edison bulb direct trade gentrify beard lo-fi seitan sustainable roof party franzen occupy squid. Knausgaard cronut succulents, scenester readymade shabby chic lyft. Copper mug meh vegan gentrify.',
    },
    {
        id: 5,
        title: 'Notification 5 Notification 8 Notification 8',
        info: 'Locavore franzen fashion axe live-edge neutra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwave blog, microdosing thundercats migas vaporware viral lo-fi seitan ',
    },
    {
        id: 6,
        title: 'Notification 6 Notification 8 Notification 8 ',
        info: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis inventore blanditiis, quaerat laboriosam assumenda ad similique provident, suscipit nihil voluptate quia! Quo aliquam facere, ipsum sunt dolore ex iste non?',
    },
    {
        id: 7,
        title: 'Notification 7 Notification 8 Notification 8 Notification 8 Notification 8 Notification 8',
        info: 'Locavore franzen fashion axe live-edge neutra irony synth af tilde shabby chic maraid chillwave waistcoat copper mug messenger bag. Banjo snackwave blog, microdosing thundercats migas vaporware viral lo-fi seitan ',
    },
    {
        id: 8,
        title: 'Notification 8 Notification 8 Notification 8',
        info: 'Locavore franzen ashion axe live-edgetra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwave blog, microdosing thundercats migas vaporware viral lo-fi seitan ',
    },
    {
        id: 9,
        title: 'Notification 9 Notification 8 Notification 8',
        info: 'Locavore franzen fashion axe live-edge neutra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwav blog, microdosg thundercats migas vaporware viral lo-fi seitan ',
    },
    {
        id: 10,
        title: 'Notification 10',
        info: 'Locavore franzen fashion axe live-edge neutra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwave bog, microdosing thundercats migas vaporware viral lo-fi seitan ',
    },
    {
        id: 11,
        title: 'Notification 11',
        info: 'Locavore franzen fashin axe live-edge neutra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwave blog, microdosing thundercats migas vaporware viral lo-fi seitan ',
    },
    {
        id: 12,
        title: 'Notification 12',
        info: 'Locavore franzen fashion axe live-edge neutra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwave blog, microsing thundercats migas vaporware viral lo-fi seitan ',
    },
    {
        id: 13,
        title: 'Notification 13',
        info: 'Locavore franzeshion axe live-edge neutra irony synth af tilde shabby chic man braid chillwave waistcoat copper mug messenger bag. Banjo snackwave blog, microdosing thundercats migas vaporware viral lo-fi seitan ',
    },
]
export default questions